export default __webpack_public_path__ + "static/media/aral_plus.3cbdaf28.svg";